import React, { type PropsWithChildren } from 'react';

import type { ExtensionParams, Parameters } from '@atlaskit/editor-common/extensions';

import { ExperienceTimeout } from '@confluence/experience-tracker';
import {
	MacroExperienceStart,
	getMacroAttributesFromADFNode,
	EDITOR,
	getExperienceName,
} from '@confluence/macro-tracker';
import { SessionData, SessionDataContext } from '@confluence/session-data';
import type { SessionDataType } from '@confluence/session-data';

import { CustomSitesExtensionNoDataComponent } from './CustomSitesExtensionNoDataComponent';

export type CustomSitesExtensionProps<T extends Parameters> = {
	extensionNode: ExtensionParams<T>;
	contentId: string;
};

export const CustomSitesExtension = <T extends Parameters>({
	extensionNode,
	contentId,
	showNoDataState,
	children,
}: PropsWithChildren<CustomSitesExtensionProps<T> & { showNoDataState: boolean }>) => {
	const { extensionKey } = extensionNode;
	const macroAttributes = getMacroAttributesFromADFNode(extensionNode);

	return (
		<SessionData>
			{(sessionData: SessionDataType) => (
				<SessionDataContext.Provider value={sessionData}>
					<MacroExperienceStart
						name={getExperienceName(EDITOR, extensionNode)}
						contentId={contentId}
						mode={EDITOR}
						extensionKey={extensionKey}
						attributes={macroAttributes}
						timeout={ExperienceTimeout.MACRO_LOAD}
					/>
					{!showNoDataState ? (
						children
					) : (
						<CustomSitesExtensionNoDataComponent source={extensionKey} />
					)}
				</SessionDataContext.Provider>
			)}
		</SessionData>
	);
};
